import axios from 'utils/axios';

export const analyseText = async (data) => {
    try {
        const response = await axios.post('trigger-words/analyse-text', data);
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const getPackage = async (packageName) => {
    try {
        const response = await axios.get('trigger-words/get-package', {
            params: { packageName }
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const updateWordsProfile = async (data) => {
    try {
        const response = await axios.post('trigger-words/update-words-profile', data);
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
